import httpClient from "./httpClient";

export const getInsights = async () => {
  return await httpClient.get("/api/insights");
};
